var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.803,
    y: 13.801,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 45.623 -18.8971)",
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 0.8796,
    width: 63.638,
    height: 63.64
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.395,66.396 69.924,66.396 45.611,90.623"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.843,24.847 21.314,24.847 45.623,0.62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLq);
export default __webpack_public_path__ + "static/media/lq.2650b9f3.svg";
export { ForwardRef as ReactComponent };